module.exports = __webpack_public_path__ + "static/media/sf-skyline-mobile.16815d02.png";